var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSorter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.75008L2.99996 0.416748L0 3.75008H2V8.59121C2 8.82121 2.18667 9.00006 2.41667 9.00006H3.58333C3.81333 9.00006 4 8.82121 4 8.59121V3.75008H6Z",
    fill: "#828E99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorter);
export default __webpack_public_path__ + "static/media/sorter.017785d7.svg";
export { ForwardRef as ReactComponent };